<article>
  <div class="header bg-white">
    <div class="container-fluid">
      <div class="header-body">
        <div class="row align-items-center py-3 bg-head-light mb-2">
          <div class="col-lg-6 col-5">
            <h1 style="justify-content: center;" class="h3 mb-0">Support & Accessories Request</h1>
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
              <ol class="breadcrumb breadcrumb-links breadcrumb-dark mt-2">
                <li class="breadcrumb-item">
                  <i class="fas fa-home"></i>
                </li>
                <li class="breadcrumb-item"><a routerLink="/dashboard">Dashboard</a></li>
                <li class="breadcrumb-item active" aria-current="page">
                  Support Request
                </li>
              </ol>
            </nav>
          </div>
          <div class="col-lg-6 col-7 text-right">
            <div class="quick-filter">
              <input type="text" (keyup)="onQuickFilterChanged()" class="form-control" [(ngModel)]="quickSearchValue"
                placeholder="search..." /><i class="fa fa-search"></i>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="p-3">
    <ag-grid-angular style=" height: 72vh;" class="ag-theme-balham" [enableSorting]="true" [enableFilter]="true"
      [rowData]="rows" [rowHeight]="40" [enableCellTextSelection]="true" [pagination]="true" [columnDefs]="columnDefs"
      (modelUpdated)="onModelUpdated()" (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)">
    </ag-grid-angular>

    <div class="modal " id="myModal" [style.display]="addSupport ? 'block' : 'none'" style="overflow: auto;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header" style="background-color: #7146EB !important;color:white">
            <h3 style="text-align:center !important; color:white;">New Support & Accessories Request</h3>
            <button type="button" class="close" data-dismiss="modal" (click)="hide()">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="modal-body clearfix" style="padding: 0;">
            <div class="form-group has-feedback">
              <form [formGroup]="supportAndAccessoriesRequestForm" (ngSubmit)="onSupport()">
                <div class="form-group">
                  <div class="form-group-content">
                    <div class="row">
                      <div class=" col-md-4">
                        <label class="control-label" for="MerchantName">Merchant Name</label>
                        <p>{{editRow.merchant}}</p>
                      </div>
                      <div class=" col-md-4">
                        <label class="control-label" for="MerchantId">Merchant Id</label>
                        <p>{{editRow.idMerchant}}</p>
                      </div>
                      <div class="col-md-4">

                        <label class="control-label" for="TerminalId">Terminal Id</label>
                        <p>{{editRow.idTerminal}}</p>
                      </div>
                      <div class="col-md-4">
                        <label class="control-label" for="TerminalType">Terminal Type</label>
                        <p>{{editRow.item}}</p>
                      </div>
                      <div class=" col-md-4">
                        <label class="control-label" for="SerialKey">Serial Key</label>
                        <p>{{editRow.serialKey}}</p>
                      </div>
                      <div class="col-md-4">
                        <label class="control-label" for="Connectivity">Connectivity</label>
                        <p>{{editRow.connectivity}}</p>
                      </div>
                    </div>
                    <div *ngIf="editRow.isSupportPresent" class="row">
                      <span style="color: red;">
                        Support Already Exists !!

                      </span>
                    </div>

                  </div>
                  <div class="container">
                    <div *ngIf="!editRow.isSupportPresent">
                      <p style="color:rgb(15, 15, 15);" class="font-medium mb-2">Select Request:</p>
                      <label *ngFor="let radiobutton of radioItems">
                        <input type="radio" name="options" (click)="uploadTypeChange(radiobutton)"
                          [checked]="radiobutton.id == uploadType">
                        &nbsp;&nbsp; {{radiobutton.type}}&nbsp;&nbsp;
                      </label>
                    </div>

                    <merchant-support-request *ngIf="uploadType == 1"></merchant-support-request>
                    <merchant-accessories-request *ngIf="uploadType == 2"></merchant-accessories-request>

                    <div *ngIf="uploadType == 3">
                      <p style="color:rgb(15, 15, 15);" class="font-medium mb-2">Add Support Request:</p>
                      <form formGroupName="supportForm">
                        <div class="content-padding">
                          <div class="row">
                            <div class="col-md-6">
                              <label for="name">Contact Person<span class="required-sign"
                                  style="color: red">*</span></label>
                              <input type="text" class="form-control" id="contactPerson" name="BankName" value=""
                                formControlName="contactPerson"
                                [ngClass]="{ 'is-invalid': submitted && f.supportForm.controls.contactPerson.errors }"
                                placeholder="Contact Person">
                              <div *ngIf="submitted && f.supportForm.controls.contactPerson.errors"
                                class="invalid-feedback">
                                <div *ngIf="f.supportForm.controls.contactPerson.errors.required">Contact Person is
                                  required</div>
                              </div>
                            </div>
                            <div class="col-md-6">

                              <label for="name">Contact No<span class="required-sign"
                                  style="color: red">*</span></label>
                              <input type="text" class="form-control" id="contactNo" name="contactNo" value=""
                                maxlength="10" formControlName="contactNo" placeholder="Contact Number"
                                [ngClass]="{ 'is-invalid': submitted && f.supportForm.controls.contactNo.errors }">
                              <div *ngIf="submitted && f.supportForm.controls.contactNo.errors"
                                class="invalid-feedback">
                                <div *ngIf="f.supportForm.controls.contactNo.errors.required">Contact Number is
                                  required
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6">

                              <label for="name">Issue<span class="required-sign" style="color: red">*</span></label>
                              <select id="issue" class="form-control" name="issue" formControlName="issue"
                                [ngClass]="{ 'is-invalid': submitted && f.supportForm.controls.issue.errors }">
                                <option *ngFor="let p of issueType" [value]="p.text">
                                  <span> {{p.text }} </span>
                                </option>
                              </select>
                              <div *ngIf="submitted && f.supportForm.controls.issue.errors" class="invalid-feedback">
                                <div *ngIf="f.supportForm.controls.issue.errors.required">
                                  Issue is required</div>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <label for="name">Remarks</label>
                              <input type="text" class="form-control" id="Remarks" name="remarks" value=""
                                formControlName="remarks" placeholder="Remarks">
                            </div>
                            <div class="form-group">
                              <label>
                                <input type="radio" value=0 formControlName="isFieldSupport">
                                <span>Phone</span>
                              </label>
                              <label>
                                <input type="radio" value=1 formControlName="isFieldSupport">
                                <span>field</span>
                              </label>
                              <div *ngIf="submitted && f.supportForm.controls.isFieldSupport.errors"
                                class="invalid-feedback">
                                <div *ngIf="f.supportForm.controls.isFieldSupport.errors.required"> Support Type is
                                  required</div>
                              </div>
                            </div>
                            <div class="form-group">
                              <label class="checkbox-inline" for="priority">
                                <input type="checkbox" name="priority" formControlName="priority" />
                                <p>Priority</p>
                              </label>
                            </div>
                          </div>
                        </div>
                      </form>
                      <form formGroupName="accesoriesForm">
                        <p style="color:rgb(15, 15, 15);">Add Accessories Request:</p>
                        <div *ngFor="let itemrow of itemRows.controls; let i=index" [formGroupName]="i">
                          <h4 class="col-sm-1"> #{{i+1}}</h4>
                          <div class="content-padding">
                            <div class="row">
                              <div class="col-md-6">
                                <label>Accessories Type<sup class="required-sign">*</sup></label>
                                <select formControlName="accessoryId" formControlName="accessoryId" class="form-control"
                                  name="accessoryId" id="accessoryId" class="form-control"
                                  [ngClass]="{'is-invalid': submitted && f.accesoriesForm.controls.itemRows.controls[i].get('inventoryId').errors}">
                                  <option *ngFor="let accessory of accessoriesList" [value]="accessory.accessoryId" class="drop">
                                    <span>
                                      {{ accessory.item }}
                                    </span>
                                  </option>
                                </select>
                                <div *ngIf="itemRows.controls[i].get('accessoryId')?.errors?.required && submitted"
                                  class="invalid-feedback">
                                  Accessories is required.
                                </div>
                              </div>
                              <div class="col-md-6">
                                <label>Quantity<sup class="required-sign">*</sup></label>
                                <input type="number" class="form-control" formControlName="quantity" id="quantity"
                                  name="quantity" pattern="^[1-9][0-9]*$"
                                  oninput="if(!this.value.match('^[1-9][0-9]*$'))this.value='';"
                                  placeholder="Enter Quantity"
                                  [ngClass]="{ 'is-invalid': submitted && f.accesoriesForm.controls.itemRows.controls[i].get('quantity').errors}">
                                <div *ngIf="itemRows.controls[i].get('quantity')?.errors?.required && submitted"
                                  class="invalid-feedback">
                                  Quantity is required.
                                </div>
                              </div>
                            </div>
                            <br/>
                            <button type="button" (click)="addNewRow()" class="btn btn-primary btn-sm"><i
                                class="fa-solid fa-plus btn-secondary"></i>Add</button>
                            <button
                              *ngIf="supportAndAccessoriesRequestForm.get('accesoriesForm').controls.itemRows.controls.length > 1"
                              (click)="deleteAccesoriesRequestRow(i)" class="btn btn-danger btn-sm">
                              <i class="fa-solid fa-minus"></i>Remove</button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div class="form-group col-md-auto text-right">
                    <button *ngIf="!isReqSave" class="btn btn-neutral" type="submit" style=" margin: 0 auto;">
                      <span class="spinner-border spinner-border-sm mr-1"></span>
                      Add Request
                    </button>
                    <button *ngIf="isReqSave" color="success" [disabled]="isReqSave" class="btn btn-warning"
                      style="font-size: 13px; float: right; width: auto;margin: 7px auto; border-radius: 30px">Adding
                      Requesting...
                    </button>
                  </div>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div *ngIf="this.addedRow.length != 0 ">
      <div class="py-3 bg-white my-6" style="width: 2000px;">
        <h4 class="title p-0 mb-3"><i class="fa fa-clock-o"></i> Added Support Request</h4>
        <table class="table table-striped table-bordered mb-0">
          <thead>
            <tr>
              <th scope="col">SN</th>
              <th scope="col">Merchant Name</th>
              <th scope="col">Merchant Id</th>
              <th scope="col">Terminal Id</th>
              <th scope="col">Terminal Type</th>
              <th scope="col">Serial Key</th>
              <th scope="col">Connectivity</th>
              <th scope="col">Contact Person</th>
              <th scope="col">Contact No</th>
              <th scope="col">Issue</th>
              <th scope="col">Remarks</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of addedRow; let i = index;">
              <td> {{i+1}} </td>
              <td>{{row.MerchantName}} </td>
              <td>{{row.MerchantId}} </td>
              <td>{{row.TerminalId}} </td>
              <td> {{row.TerminalType}} </td>
              <td> {{row.SerialKey}} </td>
              <td> {{row.Connectivity}} </td>
              <td>{{row.ContactPerson}}</td>
              <td> {{row.ContactNo}} </td>
              <td> {{row.Issue}} </td>
              <td> {{row.Remarks}} </td>
              <td><button class="btn btn-primary" (click)="edit(i)"
                  style="font-size: 12px; font-weight: normal;padding: 5px 20px !important;height: auto;line-height: normal;">
                  Edit </button>
                <button class="btn btn-danger" (click)="deleteRow(i)"
                  style="font-size: 12px; font-weight: normal;padding: 5px 20px !important;height: auto;line-height: normal;margin-left: 10px;">
                  Delete </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- <div class="clearfix">
        <button *ngIf="!isReqSave" color="success" (click)="SubmitDeploymentRequest()" class="btn btn-success"
          style="font-size: 13px; float: center; width: auto;margin: 7px auto; border-radius: 30px">Submit Request
        </button>
        <button *ngIf="isReqSave" color="success" [disabled]="loading" class="btn btn-warning"
          style="font-size: 13px; float: right; width: auto;margin: 7px auto; border-radius: 30px">Submitting
          Request </button>
      </div> -->
    </div>
  </div>
</article>